import { Turbo } from "@hotwired/turbo-rails";
import TurboPower from "turbo_power";
TurboPower.initialize(Turbo.StreamActions);

import "../controllers";

import "../hashcash";

import { preventTurboFouce } from "https://ka-p.webawesome.com/kit/2d987bddc938420a/webawesome@3.0.0/webawesome.js";

preventTurboFouce();

import { init } from "@plausible-analytics/tracker";

init({
  domain: "kliip.it",
});
